import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient  } from "@angular/common/http";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
// import { SchoolregistrationComponent } from './schoolregistration/schoolregistration.component';
import { NewSchoolRegistrationComponent } from "./new-school-registration/new-school-registration.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DashboardV2Component } from "./dashboard-v2/dashboard-v2.component";
import { HeaderComponent } from "./header/header.component";
import { HeaderV2Component } from "./header-v2/header-v2.component";
import { HeaderV3Component } from "./header-v3/header-v3.component";
import { CountUpDirective } from "./directives/count-up.directive";
import { RowEntranceDirective } from "./directives/row-entrance.directive";
import { FeesManageV2Component } from "./feesmanage-v2/feesmanage-v2.component";
import { TransportV2Component } from "./transport-v2/transport-v2.component";
import { AdmissionV2Component } from "./admission-v2/admission-v2.component";
import { LayoutComponent } from "./layout/layout.component";
import { StaffLayoutComponent } from "./staff/layout/staff-layout.component";
import { StaffAdminVerifyModalComponent } from "./staff/shared/staff-admin-verify-modal/staff-admin-verify-modal.component";
import { StaffHomeComponent } from "./staff/home/staff-home.component";
import { StaffDashboardComponent } from "./staff/dashboard/staff-dashboard.component";
import { StaffClassOverviewComponent } from "./staff/class-overview/staff-class-overview.component";
import { StaffClassDiaryComponent } from "./staff/class-diary/staff-class-diary.component";
import { StaffClassAttendanceComponent } from "./staff/class-attendance/staff-class-attendance.component";
import { StaffPeriodWiseAttendanceComponent } from "./staff/period-wise-attendance/staff-period-wise-attendance.component";
import { StaffClassChatComponent } from "./staff/class-chat/staff-class-chat.component";
import { StaffClassActivityComponent } from "./staff/class-activity/staff-class-activity.component";
import { StaffClassStudentsComponent } from "./staff/class-students/staff-class-students.component";
import { StaffClassTimetableComponent } from "./staff/class-timetable/staff-class-timetable.component";
import { StaffMyTimetableComponent } from "./staff/my-timetable/staff-my-timetable.component";
import { StaffPagenotfoundComponent } from "./staff/pagenotfound/staff-pagenotfound.component";
import { StaffStudentDetailComponent } from "./staff/student-detail/staff-student-detail.component";
import { StaffProfileComponent } from "./staff/profile/staff-profile.component";
import { StaffMemberProfileComponent } from "./staff/staff-member-profile/staff-member-profile.component";
import { StaffBroadcastComponent } from "./staff/broadcast/staff-broadcast.component";
import { StaffAcademicCalendarComponent } from "./staff/academic-calendar/staff-academic-calendar.component";
import { StaffFeesComponent } from "./staff/fees/staff-fees.component";
import { StaffFeesMonthlyComponent } from "./staff/fees-monthly/staff-fees-monthly.component";
import { StaffFeesReportComponent } from "./staff/fees-report/staff-fees-report.component";
import { StaffFeesReportStudentsComponent } from "./staff/fees-report-students/staff-fees-report-students.component";
import { StaffFeesReportStudentHistoryComponent } from "./staff/fees-report-student-history/staff-fees-report-student-history.component";
import { StaffFeesReportOverdueStudentsComponent } from "./staff/fees-report-overdue-students/staff-fees-report-overdue-students.component";
import { StaffFeesReportOverdueStudentHistoryComponent } from "./staff/fees-report-overdue-student-history/staff-fees-report-overdue-student-history.component";
import { StaffTransportComponent } from "./staff/transport/staff-transport.component";
import { StaffCheckInComponent } from "./staff/checkin/staff-checkin.component";
import { StaffViewAttendanceComponent } from "./staff/view-attendance/staff-view-attendance.component";
import { StaffLeaveManagementComponent } from "./staff/leave-management/staff-leave-management.component";
import { StaffSearchComponent } from "./staff/search/staff-search.component";
import { AdmissionComponent } from "./admission/admission.component";
import { FeesManagementComponent } from "./feesmanage/feesmanage.component";
import { TransportComponent } from "./transport/transport.component";
import { GroupsComponent } from "./groups/groups.component";
import { GroupsV2Component } from "./groups-v2/groups-v2.component";
import { LoaderComponent } from "./loader/loader.component";
import { MenuComponent } from "./menu/menu.component";
import { PopupComponent } from "./popup/popup.component";
import { ConfirmationPopupComponent } from "./confirmation-popup/confirmation-popup.component";
import { ErrorPopupComponent } from "./error-popup/error-popup.component";
import { SendSmsComponent } from "./sendSms/sendSms.component";
import { SmsMessageComponent } from "./smsmessage/smsmessage.component";
import { StudentBasicInfoComponent } from "./student-basic-info/student-basic-info.component";
import { StudentContactInfoComponent } from "./student-contact-info/student-contact-info.component";
import { StudentDeactivateComponent } from "./student-deactivate/student-deactivate.component";
import { StudentProfileViewComponent } from "./student-profile-view/student-profile-view.component";
import { StudentTransportSettingsComponent } from "./student-transport-settings/student-transport-settings.component";
import { AcademicsComponent } from "./academics/academics.component";
import { TimetableTimeClashComponent } from "./classmanage/timetable-time-clash/timetable-time-clash.component";
import { ClassmanageComponent } from "./classmanage/classmanage.component";
import { ClassManageV2Component } from "./classmanage-v2/classmanage-v2.component";
import { TimetableTimeClashV2Component } from "./classmanage-v2/timetable-time-clash-v2/timetable-time-clash-v2.component";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FormsModule, NgSelectOption } from "@angular/forms";
import { ExamComponent } from "./exams/exam.component";
import { ExpensesComponent } from "./expenses/expense.component";
import { SettingsComponent } from "./settings/settings.component";
import { NewLoginComponent } from "./new-login/new-login.component";
import { PagenotfoundComponent } from "./pagenotfound/pagenotfound.component";
import { SchoolSuspendedComponent } from "./schoolsuspended/schoolsuspended.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { FranchiseComponent } from "./franchise/franchise.component";
import { SchoollistComponent } from "./franchise/schoollist.component";
import { FranchiseSettingsComponent } from "./franchise/settings.component";
import { AddSchoolComponent } from "./franchise/addschool.component";
import { SchoolregistrationComponent } from "./schoolregistration/schoolregistration.component";
import { SliderComponent } from "./slider/slider.component";
import { ButtonLoaderComponent } from "./button-loader/button-loader.component";
import { SchoolDetailsComponent } from "./school-details/school-details.component";
import { NewLoginWithDomainComponent } from "./new-login-with-domain/new-login-with-domain.component";
import { NewLoginWithDomainVerificationComponent } from "./new-login-with-domain-verification/new-login-with-domain-verification.component";
import { ReactiveFormsModule } from '@angular/forms';
import { SchoolRegistrationUnderVerificationComponent } from "./school-registration-under-verification/school-registration-under-verification.component";
import { ParentLoginComponent } from "./parent-login/parent-login.component";
import { ParentDiaryComponent } from "./parent-diary/parent-diary.component";
import { ParentAttendanceComponent } from "./parent-attendance/parent-attendance.component";
import { ParentTimetableComponent } from "./parent-timetable/parent-timetable.component";
import { ParentLeaveRequestComponent } from "./parent-leave-request/parent-leave-request.component";
import { ParentFeesComponent } from "./parent-fees/parent-fees.component";
import { ParentFeesPaymentComponent } from "./parent-fees/parent-fees-payment.component";
import { ParentDocumentHubComponent } from "./parent-document-hub/parent-document-hub.component";
import { ParentBroadcastComponent } from "./parent-broadcast/parent-broadcast.component";
import { ParentChatComponent } from "./parent-chat/parent-chat.component";
import { ParentNotificationsComponent } from "./parent-notifications/parent-notifications.component";
import { ParentMyTeacherComponent } from "./parent-my-teacher/parent-my-teacher.component";
import { ParentAcademicCalendarComponent } from "./parent-academic-calendar/parent-academic-calendar.component";
import { ParentActivityComponent } from "./parent-activity/parent-activity.component";
import { ParentFeedbackComponent } from "./parent-feedback/parent-feedback.component";
import { serviceInterceptor } from "./service.interceptor";
import { StaffApiInterceptor } from "./staff/staff-api.interceptor";
import { LogoutModalComponent } from "../app/logout-modal/logout-modal.component";
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { NewLoaderComponent } from "./new-loader/new-loader.component";
import { ServerDownComponent } from "./server-down/server-down.component";
import { EditStudentPopupComponent } from "./edit-student-popup/edit-student-popup.component";
import { EditStudentPopupV2Component } from "./edit-student-popup-v2/edit-student-popup-v2.component";
import { TcGenerationComponent } from "./tc-generation/tc-generation.component";
import { CategoryWiseReportComponent } from "./category-wise-report/category-wise-report.component";
import { BroadcastComponent } from "./broadcast/broadcast.component";
import { BroadcastV2Component } from "./broadcast-v2/broadcast-v2.component";
import { TransferCertificatePreviewComponent } from "./transfer-certificate-preview/transfer-certificate-preview.component";
import { AcademicCalendarComponent } from "./academic-calendar/academic-calendar.component";
import { FullCalendarModule } from "@fullcalendar/angular";
import { EventCategoryComponent } from "./event-category/event-category.component";
import { AcademicHolidaysComponent } from "./academic-holidays/academic-holidays.component";
import { NgSelectModule } from '@ng-select/ng-select';
import { TransferCertificateReportComponent } from "./transfer-certificate-report/transfer-certificate-report.component";
import { AttendanceReportComponent } from "./attendance-report/attendance-report.component";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { PendingFeesReportComponent } from "./pending-fees-report/pending-fees-report.component";
import { IdCardComponent } from "./id-card/id-card.component";
import { ViewIdCardComponent } from "./view-id-card/view-id-card.component";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageDropdownComponent } from "./language-dropdown/language-dropdown.component"
import { ExpenseReportComponent } from "./expense-report/expense-report.component";
import { InsightsComponent } from "./insights/insights.component";
import { AdmissionInquiryComponent } from "./admission-inquiry/admission-inquiry.component";
import { MultiSelectModule } from 'primeng/multiselect';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CountrySelectComponent } from 'an-country-code-selector';
import { CalendarModule } from 'primeng/calendar';
    import { PaginatorModule } from 'primeng/paginator';
      import { DialogModule } from 'primeng/dialog';
      import { FloatLabelModule } from 'primeng/floatlabel';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from "primeng/inputswitch";
import { ChipModule } from "primeng/chip";
import {CheckinCheckoutReportComponent} from './checkin-checkout-report/checkin-checkout-report.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FeesOverdueReportComponent } from "./fees-overdue-report/fees-overdue-report.component";
import { CalendarComponent } from 'ng-full-calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        SchoolregistrationComponent,
        NewSchoolRegistrationComponent,
        DashboardComponent,
        DashboardV2Component,
        HeaderComponent,
        HeaderV2Component,
        HeaderV3Component,
        CountUpDirective,
        RowEntranceDirective,
        FeesManageV2Component,
        TransportV2Component,
        ClassManageV2Component,
        TimetableTimeClashV2Component,
        AdmissionV2Component,
        LayoutComponent,
        StaffLayoutComponent,
        StaffAdminVerifyModalComponent,
        StaffHomeComponent,
        StaffDashboardComponent,
        StaffClassOverviewComponent,
        StaffClassDiaryComponent,
        StaffClassAttendanceComponent,
        StaffPeriodWiseAttendanceComponent,
        StaffClassChatComponent,
        StaffClassActivityComponent,
        StaffClassStudentsComponent,
        StaffClassTimetableComponent,
        StaffMyTimetableComponent,
        StaffPagenotfoundComponent,
        StaffStudentDetailComponent,
        StaffProfileComponent,
        StaffMemberProfileComponent,
        StaffBroadcastComponent,
        StaffAcademicCalendarComponent,
        StaffFeesComponent,
        StaffFeesMonthlyComponent,
        StaffFeesReportComponent,
        StaffFeesReportStudentsComponent,
        StaffFeesReportStudentHistoryComponent,
        StaffFeesReportOverdueStudentsComponent,
        StaffFeesReportOverdueStudentHistoryComponent,
        StaffTransportComponent,
        StaffCheckInComponent,
        StaffViewAttendanceComponent,
        StaffLeaveManagementComponent,
        StaffSearchComponent,
        AdmissionComponent,
        FeesManagementComponent,
        GroupsComponent,
        GroupsV2Component,
        TransportComponent,
        LoaderComponent,
        MenuComponent,
        PopupComponent,
        ConfirmationPopupComponent,
        ErrorPopupComponent,
        SendSmsComponent,
        SmsMessageComponent,
        StudentBasicInfoComponent,
        StudentContactInfoComponent,
        StudentDeactivateComponent,
        StudentProfileViewComponent,
        StudentTransportSettingsComponent,
        AcademicsComponent,
        TimetableTimeClashComponent,
        ClassmanageComponent,
        ExamComponent,
        TcGenerationComponent,
        ExpensesComponent,
        SettingsComponent,
        NewLoginComponent,
        PagenotfoundComponent,
        SchoolSuspendedComponent,
        FranchiseComponent,
        SchoollistComponent,
        FranchiseSettingsComponent,
        AddSchoolComponent,
        SchoolDetailsComponent,
        NewLoginWithDomainComponent,
        NewLoginWithDomainVerificationComponent,
        SchoolRegistrationUnderVerificationComponent,
        ParentLoginComponent,
        ParentDiaryComponent,
        ParentAttendanceComponent,
        ParentTimetableComponent,
        ParentLeaveRequestComponent,
        ParentFeesComponent,
        ParentFeesPaymentComponent,
        ParentDocumentHubComponent,
        ParentBroadcastComponent,
        ParentChatComponent,
        ParentNotificationsComponent,
        ParentMyTeacherComponent,
        ParentAcademicCalendarComponent,
        ParentActivityComponent,
        ParentFeedbackComponent,
        NewLoaderComponent,
        ServerDownComponent,
        EditStudentPopupComponent,
        EditStudentPopupV2Component,
        CategoryWiseReportComponent,
        BroadcastComponent,
        BroadcastV2Component,
        TransferCertificatePreviewComponent,
        TransferCertificateReportComponent,
    AttendanceReportComponent,
        AcademicCalendarComponent,
        EventCategoryComponent,
        CheckinCheckoutReportComponent,
        AcademicHolidaysComponent,
        IdCardComponent,
        PendingFeesReportComponent,
        LanguageDropdownComponent,
        ViewIdCardComponent,
        ExpenseReportComponent,
        InsightsComponent,
        FeesOverdueReportComponent,
        AdmissionInquiryComponent
    ],
    imports: [
    InputSwitchModule,
    ChipModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    DragDropModule,
    SliderComponent,
    ButtonLoaderComponent,
    NgMultiSelectDropDownModule.forRoot(),
    ReactiveFormsModule,
    LogoutModalComponent,
    LottieComponent,
    NgxDaterangepickerMd.forRoot(),
    CalendarComponent,
    FullCalendarModule,
    NgSelectModule,
      MultiSelectModule,
        TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MultiSelectModule,
    FormsModule,
    BrowserAnimationsModule,
    CountrySelectComponent,
    CalendarModule,
    PaginatorModule,
    SkeletonModule,
    InputSwitchModule,
    ProgressSpinnerModule,
    DialogModule,
    FloatLabelModule,
    CheckboxModule,
    ToastModule,
    TableModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule
],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy }, {
            provide: HTTP_INTERCEPTORS,
            useClass: serviceInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: StaffApiInterceptor,
            multi: true
        },
        MessageService,
        provideLottieOptions({
            player: () => import('lottie-web'),
        }),],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }